module.exports = __webpack_public_path__ + "img/errTicket.efffb06b.png";